<template>
  <ChartFrame :title="$t('Chart__AgeStructure__name')">
    <RadioButtons
      class="fmhind-graph-age-structure__radio"
      :options="sectors"
      v-model="currentSector"
    />
    <RadioButtons
      class="fmhind-graph-age-structure__radio"
      :options="sheetNames"
      v-model="currentSheetName"
    />
    <ApexChart ref="chart" :options="options" :series="currentDataSeries" />
  </ChartFrame>
</template>

<script>
import ChartFrame from '@/components/ChartPartials/ChartFrame';
import RadioButtons from '@/components/Ui/RadioButtons';
import data from '@/assets/json/AgeStructure.json';

export default {
  name: 'AgeStructure',
  components: {
    ChartFrame,
    RadioButtons
  },
  computed: {
    sectors() {
      return Array.from(
        new Set(
          this.sheets[0].series.reduce((sectors, item) => {
            sectors.push(item.name.split('/')[0]);
            return sectors;
          }, [])
        )
      );
    },
    currentSector: {
      get() {
        return this.currentSectorData
          ? this.currentSectorData
          : 'ChartText__total';
      },
      set(val) {
        this.currentSectorData = val;
      }
    },
    currentSheetName: {
      get() {
        return this.currentSheetNameData
          ? this.currentSheetNameData
          : this.sheetNames[this.sheetNames.length - 1];
      },
      set(val) {
        this.currentSheetNameData = val;
      }
    },
    currentDataSeries() {
      return this.sheets
        .find(sheet => sheet.title === this.currentSheetName)
        .series.filter(item => {
          const nameParts = item.name.split('/');
          return nameParts[0] === this.currentSector;
        })
        .map((item, index) => ({
          name: this.$t(item.name.split('/')[1]),
          data: index === 0 ? item.data.map(num => num * -1) : item.data
        }));
    }
  },
  data() {
    const sheetNames = data.map(sheet => sheet.title);
    sheetNames.sort((a, b) => parseInt(a) - parseInt(b));
    return {
      sheetNames,
      sheets: data,
      currentSectorData: null,
      currentSheetNameData: null,
      options: {
        chart: {
          type: 'bar',
          stacked: true
        },
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        xaxis: {
          categories: data[0].axis,
          labels: {
            formatter: function(val) {
              return Math.round(Math.abs(val));
            }
          }
        },
        grid: {
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        tooltip: {
          shared: false,
          x: {
            formatter(val) {
              return val;
            }
          },
          y: {
            formatter(val) {
              return Math.round(Math.abs(val));
            }
          }
        }
      }
    };
  },
  watch: {
    currentDataSeries: {
      immediate: true,
      deep: true,
      handler(val) {
        const allValues = [];
        val.forEach(series =>
          series.data.forEach(value => allValues.push(Math.abs(value)))
        );
        let max = Math.max(...allValues);
        max = Math.ceil(max / 100) * 100;
        this.$set(this.options, 'yaxis', {
          min: max * -1,
          max: max
        });
        if (this.$refs.chart && this.$refs.chart.chart) {
          this.$refs.chart.chart.updateOptions(this.options);
        }
      }
    }
  }
};
</script>

<style lang="scss"></style>
